import { useState } from "react";

/**
 * Valor de `live` de quando o vazio foi armado, até `isEmpty` cair. Ao limpar busca ou filtros o estado da consulta
 * ainda é o do vazio por um render: sem congelar, o vazio troca de texto ("nenhum cadastrado") antes da lista voltar.
 */
export function useFrozenWhileEmpty<T>(isEmpty: boolean, live: T): T {
  const [armed, setArmed] = useState<{ value: T } | null>(null);
  const next = isEmpty ? (armed ?? { value: live }) : null;
  if (next !== armed) setArmed(next);
  return armed ? armed.value : live;
}
